import { render, staticRenderFns } from "./people-stranded.vue?vue&type=template&id=f2eef900&scoped=true&"
import script from "./people-stranded.vue?vue&type=script&lang=ts&"
export * from "./people-stranded.vue?vue&type=script&lang=ts&"
import style0 from "./people-stranded.vue?vue&type=style&index=0&id=f2eef900&prod&scoped=true&lang=scss&"
import style1 from "./people-stranded.vue?vue&type=style&index=1&id=f2eef900&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2eef900",
  null
  
)

export default component.exports